import RenameIcon from '@/shared/assets/icons/renameDevice.svg?react'
import { BaseDialog, BaseInput } from '@/shared/components'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { DeviceModel, NewNameDeviceModel } from '../../types/types'

type Props = {
  modalVisible: boolean
  setModalVisible: (value: boolean) => void
  onSubmit: (data: NewNameDeviceModel) => void
  deviceData?: DeviceModel
}

export const RenameDevice = ({ modalVisible, setModalVisible, deviceData, onSubmit }: Props) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<NewNameDeviceModel>({
    defaultValues: deviceData,
  })
  useEffect(() => {
    if (deviceData) {
      reset(deviceData)
    }
  }, [deviceData, reset])

  const handleClose = () => {
    reset()
    setModalVisible(false)
  }
  return (
    <BaseDialog
      isVisible={modalVisible}
      onClose={handleClose}
      onAction={handleSubmit(onSubmit)}
      actionButtonName="Готово"
      xButton={false}
      iconTitle={<RenameIcon className="text-[var(--status-purple-fill)]" />}
    >
      <div className="flex flex-col gap-6">
        <p className="text-[20px]">Переименование устройства</p>
        <form onSubmit={() => {}} className="w-full">
          <BaseInput
            label="Название устройства"
            variant="secondary"
            className="text-sm"
            placeholder="Придумайте название для устройства"
            {...register('name', {
              required: 'Поле обязательно',
              minLength: { value: 2, message: 'Мин. 2 символа' },
            })}
            error={errors.name?.message}
          />
        </form>
      </div>
    </BaseDialog>
  )
}
